import { jsx as _jsx } from "react/jsx-runtime";
export function Badge({ children }) {
    return _jsx("span", { className: "badge is-info", children: children });
}
//# sourceMappingURL=Badge.js.map